import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Endpoints, Mutations } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import { NotifyHelpers } from '@/ts/helpers/NotifyHelpers';

@Module({name: 'Tags', namespaced: true})
export default class Tags extends VuexModule {
    public tags: any = [];
    public socialTags: any = [];
    public educationalTags: any = [];
    public professionTags: any = [];

    @Mutation
    public RESET_TAGS_STORE_STATE() {
        this.tags            = [];
        this.socialTags      = [];
        this.educationalTags = [];
        this.professionTags  = [];
    }

    get getTags() {
        return this.tags;
    }

    get getEducationalTags() {
        return this.educationalTags;
    }

    get getSocialTags() {
        return this.socialTags;
    }

    get getProfessionTags() {
        return this.professionTags;
    }

    @Action
    public FETCH_TAGS(data: any) {
        axios.get(Endpoints.Tags.FETCH_TAGS(data.type))
            .then((response) => {
                store.commit(Mutations.SET_TAGS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public CREATE_SOCIAL_TAG(data: any) {
        axios.post(Endpoints.Admin.Tags.SOCIAL_TAG, data)
            .then((response) => {
                NotifyHelpers.notify('tag_has_been_created_and_added_to_your_interests', 'positive');
                store.commit(Mutations.SET_SOCIAL_TAG, response.data);
                store.commit(Mutations.ADD_SOCIAL_TAG, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public CREATE_EDUCATIONAL_TAG(data: any) {
        axios.post(Endpoints.Admin.Tags.EDUCATIONAL_TAG, data)
            .then((response) => {
                NotifyHelpers.notify('tag_has_been_created_and_added_to_your_educational_institution', 'positive');
                store.commit(Mutations.SET_EDUCATIONAL_TAG, response.data);
                store.commit(Mutations.ADD_EDUCATIONAL_TAG, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public SET_TAGS(tags: any) {
        this.tags = tags;
        this.socialTags = [];
        this.educationalTags = [];
        this.professionTags = [];

        tags.forEach((tag: any) => {
            if (tag.category === 'social-club') {
                this.socialTags.push(tag);
            } else if (tag.category === 'education') {
                this.educationalTags.push(tag);
            } else if (tag.category === 'profession') {
                this.professionTags.push(tag);
            }
        });
    }

    @Mutation
    public SET_SOCIAL_TAG(tag: any) {
        this.tags.push(tag);
        this.socialTags.push(tag);
    }

    @Mutation
    public SET_EDUCATIONAL_TAG(tag: any) {
        this.tags.push(tag);
        this.educationalTags.push(tag);
    }
}

